import React from "react";
import PropTypes from "prop-types";
import {
    MediumLinkButton,
    MediumPrimaryButton,
    MediumSecondaryButton,
} from "@worthy-npm/clarity";
import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 32px;
    align-items: center;

    span {
        font-weight: 400;
        margin-bottom: 40px;
    }
`;

const ButtonContainer = styled.div`
    max-width: 360px;
    width: 100%;

    & + & {
        margin-top: 20px;
    }

    button {
        width: 100%;
        margin: 0;
        height: auto;
    }

    &.secondary {
        button {
            color: #2d5dec;
            border-color: #2d5dec;
        }
    }
`;

const buttonVariants = {
    primary: MediumPrimaryButton,
    secondary: MediumSecondaryButton,
    link: MediumLinkButton,
};

const Buttons = (props) => {
    const { onChange, buttons, text } = props;
    return (
        <Container>
            <span>{text}</span>
            {buttons.map((button, i) => {
                const Button =
                    buttonVariants[button.type] || MediumPrimaryButton;

                return (
                    <ButtonContainer key={i} className={button.type}>
                        <Button
                            click={(stopAnimation) => {
                                stopAnimation();
                                onChange(button.value);
                            }}
                            text={button.text}
                            overrideCSS={{ right: 0, display: "block" }}
                        />
                    </ButtonContainer>
                );
            })}
        </Container>
    );
};

Buttons.propTypes = {
    onChange: PropTypes.func,
    buttons: PropTypes.arrayOf(PropTypes.shape({})),
    text: PropTypes.string,
};

export default Buttons;
